var map = {
	"./v2-home-certificates.svg": 5497,
	"./v2-home-channels.svg": 5498,
	"./v2-home-clp.svg": 5499,
	"./v2-home-courses.svg": 5500,
	"./v2-home-exams.svg": 5501,
	"./v2-home-gamification.svg": 5502,
	"./v2-home-leaderboard.svg": 5503,
	"./v2-home-projects.svg": 5504,
	"./v2-home-resume.svg": 5505
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5496;